import request from '@/utils/request'
import axios from 'axios'
import {
    getToken
} from '@/utils/auth';
export function editPwd(data) {
    return request({
        url: '/system/user/profile/updatePwd',
        method: 'post',
        data: data
    })
}
export function getInfo(query) {
    return request({
        url: '/system/user/profile',
        method: 'get',
        params: query
    })
}
export function editInfo(data) {
    return request({
        url: '/system/user/profile',
        method: 'put',
        data: data
    })
}
export function checkUnRead(query) {
    return request({
        url: '/oauth/server-messageCenter/messageCenter/checkUnRead',
        method: 'get',
        params: query
    })
}
export function checkNoticeUnRead(query) {
    return request({
        url: '/system/server-system/announce/notReadlist',
        method: 'get',
        params: query
    })
}
export function upload(data) {
    let config = {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + getToken()
        }
    }
    const uploadUrl = process.env.VUE_APP_BASE_API + '/system/File/uploadOssFile'
    return axios.post(uploadUrl, data, config)
}

// 用户修改密码等信息
export function setUserEditPwd(data) {
    return request({
        url: '/oauth/server-audit/userAudit/firstResetPwd',
        method: 'post',
        data: data
    })
}

// 记录用户取消修改密码
export function setUserCancelEditPwd(userId) {
    return request({
        url: `/oauth/server-audit/userAudit/cancelResetPwd/${userId}`,
        method: 'put'
    })
}

// 用户修改密码等信息
export function updatePhone(phonenumber,verifyCode) {
    return request({
        url: `/oauth/server-audit/userAudit/upddatePhoneNumber/${phonenumber}/${verifyCode}`,
        method: 'put'
    })
}

// 获取班级信息
export function getClassInfo(query) {
    return request({
        url: '/system/server-class/class/getClassInfoByUser',
        method: 'get',
        params: query
    })
}

// 获取班级学生信息
export function getStudentInfo(query) {
    return request({
        url: '/system/server-class/class/getStudentInfo',
        method: 'get',
        params: query
    })
}

// 获取班级学生汇总信息
export function getStudentSummaryInfo(query) {
    return request({
        url: '/system/server-class/class/getStatisticsClassInfo',
        method: 'get',
        params: query
    })
}

// 刷新用户token中的数据
export function refreshUserToken() {
    return request({
        url: '/oauth/server-exam/registeredClient/refreshToken',
        method: 'post'
    })
}

// 查询当前账号绑定的孩子列表，通过账号密码
export function getChildList(data) {
    return request({
        url: '/oauth/server-audit/userAudit/getStudentParent',
        method: 'post',
        data: data
    })
}

// 查询当前账号绑定的孩子列表，通过手机号验证码
export function getChildListByPhoneNumber(data) {
    return request({
        url: '/oauth/server-audit/userAudit/getStudentByPhone',
        method: 'post',
        data: data
    })
}

// 查询当前账号绑定的孩子列表，通过token
export function getChildListByToken(data) {
    return request({
        url: '/oauth/server-audit/userAudit/getStudentParentByToken',
        method: 'post',
        data: data
    })
}

// 当前账号添加孩子
export function addStudentNew(data) {
    return request({
        url: '/oauth/server-audit/userAudit/addStudentNew',
        method: 'post',
        data: data
    })
}

// 删除当前账号绑定的孩子
export function deleteStudent(data) {
    return request({
        url: `/oauth/server-audit/userAudit/deleteStudentParent/${data.studentId}`,
        method: 'delete'
    })
}

// 获取学校组织列表
export function getDeptList(query) {
    return request({
        url: '/system/server-system/product/getDeptList',
        method: 'get',
        params: query
    })
}

// 获取用户会员套餐信息
export function getMemberPackagesInfo() {
    return request({
        url: '/oauth/server-exam/authorization/getMemberPackagesInfo',
        method: 'get'
    })
}

// 获取积分商城商品列表（分页）
export function getPointShopProductList(query) {
    return request({
        url: '/system/server-system/pointProduct/getPointShopProductList',
        method: 'get',
        params: query
    })
}

// 获取积分商品详情信息
export function getPointProductDetail(id) {
    return request({
        url: `/system/server-system/pointProduct/${id}`,
        method: 'get'
    })
}

// 查询当前用户积分兑换记录列表
export function getCurUserExchangeList(query) {
    return request({
        url: '/system/server-system/pointExchangeRecord/curUserExchangeList',
        method: 'get',
        params: query
    })
}

// 获取积分兑换记录详情
export function getPointExchangeRecordDetail(id) {
    return request({
        url: `/system/server-system/pointExchangeRecord/${id}`,
        method: 'get'
    })
}

// 获取当前用户积分
export function getUserPoints() {
    return request({
        url: '/system/server-system/pointExchangeRecord/getUserPoints',
        method: 'get'
    })
}

// 兑换商品。如需自定义错误展示，可传入 { skipDefaultErrorToast: true } 关闭默认 500 提示
export function exchangeProduct(productId, config = {}) {
    return request({
        url: `/system/server-system/pointExchangeRecord/exchangeProduct` + '?productId=' + productId,
        method: 'post',
        ...config,
    })
}